export default __webpack_public_path__ + "static/media/logo_white.d8313669.png";